export default "<header class=\"header big main-header\">\n  <span class=\"text-xl\">{{ title }}</span>\n</header>\n";